import { CHART_MODE_COOKIE_NAME, getDefaultChartMode } from "../chart-mode"
import {
  COLLECTION_SETTINGS_MARKETPLACE_LOGOS_COOKIE_NAME,
  getDefaultCollectionSettingsMarketplaceLogos,
} from "../collection-settings"
import {
  COLLECTION_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  CREATED_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  getDefaultFilterSidePanelState,
  PORTFOLIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  PROFILE_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
  WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME,
} from "../filter-side-panel"
import {
  getDefaultHeroHeaderView,
  HERO_HEADER_VIEW_COOKIE_NAME,
} from "../hero-header-view"
import { getDefaultItemView, ITEM_VIEW_COOKIE_NAME } from "../item-view"
import {
  ACTIVITY_SIDE_MODULE_STATE_COOKIE_NAME,
  COLLECTION_SIDE_MODULE_STATE_COOKIE_NAME,
  getDefaultSideModuleState,
  PROFILE_SIDE_MODULE_STATE_COOKIE_NAME,
  STATS_SIDE_MODULE_STATE_COOKIE_NAME,
} from "../side-module"
import {
  CREATED_STATS_TABLE_VIEW_COOKIE_NAME,
  getDefaultDiscoverStatsTableView,
  getDefaultStatsTableView,
  HOME_STATS_TABLE_VIEW_COOKIE_NAME,
  PORTFOLIO_STATS_TABLE_VIEW_COOKIE_NAME,
  STATS_TABLE_VIEW_COOKIE_NAME,
  WATCHLIST_STATS_TABLE_VIEW_COOKIE_NAME,
} from "../stats-table-view"
import {
  DEFAULT_TOKEN_TIMEFRAME_VALUE,
  TOKEN_TIMEFRAME_PREFERENCE_COOKIE_NAME,
} from "../token-timeframe"
import type { Persona } from "./utils"

export const PERSONA_RELATED_DEFAULT_COOKIE_SETTINGS: Record<
  string,
  (persona: Persona) => string
> = {
  [CHART_MODE_COOKIE_NAME]: getDefaultChartMode,

  // Item view
  [ITEM_VIEW_COOKIE_NAME]: getDefaultItemView,

  // Hero header view
  [HERO_HEADER_VIEW_COOKIE_NAME]: getDefaultHeroHeaderView,

  // Stats table view
  [STATS_TABLE_VIEW_COOKIE_NAME]: getDefaultStatsTableView,
  [HOME_STATS_TABLE_VIEW_COOKIE_NAME]: getDefaultDiscoverStatsTableView,
  [PORTFOLIO_STATS_TABLE_VIEW_COOKIE_NAME]: getDefaultStatsTableView,
  [WATCHLIST_STATS_TABLE_VIEW_COOKIE_NAME]: getDefaultStatsTableView,
  [CREATED_STATS_TABLE_VIEW_COOKIE_NAME]: getDefaultStatsTableView,

  // Side module states
  [COLLECTION_SIDE_MODULE_STATE_COOKIE_NAME]: getDefaultSideModuleState,
  [PROFILE_SIDE_MODULE_STATE_COOKIE_NAME]: getDefaultSideModuleState,
  [ACTIVITY_SIDE_MODULE_STATE_COOKIE_NAME]: getDefaultSideModuleState,
  [STATS_SIDE_MODULE_STATE_COOKIE_NAME]: getDefaultSideModuleState,

  // Filter side panel states
  [COLLECTION_FILTER_SIDE_PANEL_STATE_COOKIE_NAME]:
    getDefaultFilterSidePanelState,
  [PROFILE_FILTER_SIDE_PANEL_STATE_COOKIE_NAME]: getDefaultFilterSidePanelState,
  [FILTER_SIDE_PANEL_STATE_COOKIE_NAME]: getDefaultFilterSidePanelState,
  [PORTFOLIO_FILTER_SIDE_PANEL_STATE_COOKIE_NAME]:
    getDefaultFilterSidePanelState,
  [WATCHLIST_FILTER_SIDE_PANEL_STATE_COOKIE_NAME]:
    getDefaultFilterSidePanelState,
  [CREATED_FILTER_SIDE_PANEL_STATE_COOKIE_NAME]: getDefaultFilterSidePanelState,

  // Collection settings
  [COLLECTION_SETTINGS_MARKETPLACE_LOGOS_COOKIE_NAME]: () =>
    getDefaultCollectionSettingsMarketplaceLogos().toString(),

  [TOKEN_TIMEFRAME_PREFERENCE_COOKIE_NAME]: () => DEFAULT_TOKEN_TIMEFRAME_VALUE,
}
